/**
 * The viewer an item tooltip is judged against: level and class for the
 * requirement lines, worn items for the compare-to-worn delta (plan 23
 * row 27, lane BI). Shared by the inventory and the NPC tome so both show
 * the same tooltip.
 */
import { useMemo } from 'react';
import { useOptionalGame } from '../contexts/GameContext';
import { useEquipment, type EquipmentSlots } from './useEquipment';
import type { ItemTooltipViewerContext, WornItemForCompare } from '../components/Tooltip';

export function wornItemsFromSlots(slots: EquipmentSlots): Record<string, WornItemForCompare | null> {
  return Object.fromEntries(Object.entries(slots).map(([slot, item]) => [
    slot, item ? { id: item.id, name: item.name, stats: item.stats } : null,
  ]));
}

export function useItemTooltipViewer(): ItemTooltipViewerContext {
  const player = useOptionalGame()?.player ?? null;
  const { slots } = useEquipment();
  const level = player?.level;
  const characterClass = player?.class;
  return useMemo(() => ({ level, characterClass, equipped: wornItemsFromSlots(slots) }), [level, characterClass, slots]);
}
